import { useRouterStore } from '../router-store';
/**
 * Utility hook for accessing the public router store
 *
 * Note that this should eventually filter out private state / actions
 */
export const useRouter = useRouterStore;